import _objectSpread from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/objectSpread";
import _slicedToArray from "C:\\a\\2\\s\\Programs\\Microservices.Common.Frontend\\ecrion-components\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/slicedToArray"; //@ts-check

import React from 'react';
import { PageContext } from './Provider';
import { Rnd } from 'react-rnd';

var PagePanel = function PagePanel(props) {
  useInsertionPoint(props);
  return null;
};

PagePanel.defaultProps = {
  defaultWidth: 240
};
var axisOptions = {
  left: true,
  right: false,
  top: false,
  bottom: false,
  topLeft: false,
  topRight: false,
  bottomLeft: false,
  bottomRight: false
};
var origin = {
  x: 0,
  y: 0
};

var useInsertionPoint = function useInsertionPoint(_ref) {
  var defaultWidth = _ref.defaultWidth,
      children = _ref.children,
      id = _ref.id;

  var _React$useContext = React.useContext(PageContext),
      _React$useContext2 = _slicedToArray(_React$useContext, 2),
      state = _React$useContext2[0],
      setState = _React$useContext2[1];

  var width = state.insertion && state.insertion.width ? state.insertion.width : defaultWidth;
  var rndRef = React.useRef(null);
  React.useEffect(function () {
    var onResize = function onResize(e, direction, ref, delta, position) {
      var newWidth = ref.offsetWidth;
      localStorage.setItem("ECR.".concat(id, ".PanelWidth"), newWidth);
      setState(function (prevState) {
        return _objectSpread({}, prevState, {
          insertion: _objectSpread({}, prevState.insertion, {
            width: newWidth
          })
        });
      }); //reset internal Rnd state

      if (rndRef.current) rndRef.current.updatePosition(origin);
    };

    if (width === defaultWidth) {
      var savedWidth = localStorage.getItem("ECR.".concat(id, ".PanelWidth"));

      if (savedWidth && parseInt(savedWidth) > 0) {
        width = parseInt(savedWidth);
      }
    }

    setState(function (prevState) {
      return _objectSpread({}, prevState, {
        insertion: {
          width: width,
          children: React.createElement(Rnd, {
            ref: rndRef,
            size: {
              width: width,
              height: '100%'
            },
            style: {
              bottom: 0
            },
            maxWidth: 600,
            minWidth: 200,
            minHeight: "100%",
            position: origin,
            onResizeStop: onResize,
            disableDragging: true,
            enableResizing: axisOptions
          }, React.createElement("div", {
            style: {
              backgroundColor: '#eee',
              height: '100%'
            }
          }, children))
        }
      });
    });
    return function () {
      setState(function (prevState) {
        return _objectSpread({}, prevState, {
          insertion: undefined
        });
      });
    };
  }, [children, width, id]);
  return state;
};

export default PagePanel;